import { useState, useEffect } from 'react';
import { AdminSystemPermissions } from '@wajeez-web/core/types';
import { Content } from '@wajeez-web/core/api-base';
import { TextAreaInput, Button } from '@wajeez-web/components/ui';
import { PlusCircleIcon } from '@heroicons/react/solid';
import { PageHeader } from '@wajeez-web/components/layouts';
import { WajeezList, WajeezRow } from '@wajeez-web/components/list-builder';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  useContentSelector,
  QuotesActions,
  ContentEntityActions,
} from '@wajeez-web/stores/content';
import { useCommonDispatch } from '@wajeez-web/stores/common';
import QuoteModal from '../../components/QuoteModal';

const ContentEntityQuotesPage = () => {
  const { id, type } = useParams() as {
    id: string;
    type: string;
  };
  const [editQuoteModalState, setEditQuoteModalState] = useState<{
    open: boolean;
    selected: number;
  }>({ open: false, selected: -1 });
  const { data, status, updatingStatus } = useContentSelector(
    (state) => state.quotes
  );
  const name = useContentSelector(
    (state) => state.contentEntity.details?.title
  );
  const [newQuotetext, setNewQuotetext] = useState('');

  const dispatch = useCommonDispatch();
  const { t } = useTranslation();

  const getListData = () => {
    dispatch(QuotesActions.getAllQuotesAsync(id));
    dispatch(ContentEntityActions.getContentEntityByIdAsync(id));
  };
  useEffect(() => {
    getListData();
    return () => {
      dispatch(QuotesActions.clear());
    };
  }, [id]);

  return (
    <>
      {editQuoteModalState.open && (
        <QuoteModal
          data={data[editQuoteModalState.selected]?.text}
          isOpen={editQuoteModalState.open}
          onClose={() => setEditQuoteModalState({ open: false, selected: -1 })}
          onSubmit={async (text) => {
            const res = await dispatch(
              QuotesActions.editQuoteAsync({
                id: data[editQuoteModalState.selected]?.id,
                text: text || '',
                languageId: 1,
              })
            );
            if (res.meta.requestStatus === 'fulfilled') {
              setEditQuoteModalState({ open: false, selected: -1 });
              getListData();
            }
          }}
        />
      )}
      <PageHeader
        title={`${t('pageHeader.Quotes')} ${name}  `}
        breadCrumbsLinks={[
          { title: 'Content-Entity', link: '/content-entities' },
          { title: type, link: `/content-entities/type/${type}` },
          { title: `${name} - Quotes` },
        ]}
      />

      <div className="p-4">
        <TextAreaInput
          placeholder="Add New Quote"
          name="newQuote"
          value={newQuotetext}
          onChange={(name, value) => setNewQuotetext(value)}
          rows={3}
          suffix={
            <Button
              type="text"
              color="primary"
              Icon={PlusCircleIcon}
              loading={updatingStatus === 'loading'}
              disabled={!newQuotetext}
              onClick={async () => {
                const res = await dispatch(
                  QuotesActions.createNewQuoteAsync({
                    contentEntityId: id,
                    text: newQuotetext,
                    languageId: 1,
                  })
                );
                if (res.meta.requestStatus === 'fulfilled') {
                  setNewQuotetext('');
                  getListData();
                }
              }}
            />
          }
        />
      </div>
      <WajeezList
        isLoading={status === 'loading'}
        data={data}
        keyExtractor={(item) => item.id || ''}
        containerType="rows"
        renderItem={(item, index) => (
          <WajeezRow
            key={item.id}
            title={item.text}
            headerActions={[
              {
                label: 'Edit',
                type: 'action',
                onClick: () => {
                  setEditQuoteModalState({ open: true, selected: index });
                },
              },
              {
                label: 'Delete',
                type: 'action',

                onClick: async () => {
                  const res = await dispatch(
                    QuotesActions.deleteQuoteAsync(item.id || '')
                  );
                  if (res.meta.requestStatus === 'fulfilled') {
                    getListData();
                  }
                },
              },
            ]}
          />
        )}
        getData={getListData}
      />
    </>
  );
};
export default ContentEntityQuotesPage;
